module.exports = __webpack_public_path__ + "img/SMS26155-L-min.cea7aa9c.png";